const pt_br = {
    header: {
        title: 'Notificações',
        'mark-all-read': 'Marcar tudo como lido',
    },
    notification: {
        'mark-as-read': 'Marcar como lido',
        'mark-as-unread': 'Marcar como não lido',
        delete: 'Apagar',
        menu: 'Menu',
    },
    'web-push-notifications': {
        notice: 'Ao ativar as notificações do navegador, você ficará ainda melhor atualizado.',
        'enable-now': 'Ativar',
    },
    messages: {
        'empty-inbox': 'Nenhuma notificação disponível!',
        'server-error': 'Não conseguimos recuperar suas notificações.<br>Por favor, volte em breve.',
        'no-internet-connection': 'Não conseguimos nos conectar à Internet.<br>Por favor, verifique sua conexão.',
    },
    preferences: {
        title: 'Preferências',
        toggle: 'Preferências de notificação',
        close: 'Fechar preferências',
    },
};
export default pt_br;
//# sourceMappingURL=pt-br.js.map